import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OrgPolicy } from '../model/org-policy';
import { HttpClient } from '@angular/common/http';
import { ENV_CONFIG } from '@libs/vc-core-lib';

@Injectable({
    providedIn: 'root',
})
export class OrgPolicyService {
    private readonly _httpClient = inject(HttpClient);
    private readonly _environment = inject(ENV_CONFIG);

    public updatePolicy(orgId: string, orgPolicy: OrgPolicy): Observable<OrgPolicy> {
        return this._httpClient.patch<OrgPolicy>(
            `${this._environment.APP.VC_POLICY_SERVICE_BASE_URL}/organization/${orgId}/policy`,
            orgPolicy
        );
    }

    public getPolicy(orgId: string): Observable<OrgPolicy> {
        return this._httpClient.get<OrgPolicy>(
            `${this._environment.APP.VC_POLICY_SERVICE_BASE_URL}/organization/${orgId}/policy`
        );
    }
}
